"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_READ_ONLY = exports.TYPE = exports.TEMPLATE_TYPE = exports.PATH = exports.LABEL = exports.IS_FROM_LAYOUT = exports.ID = exports.GENERATED_FROM_LAYOUT_ID = exports.FOLDER = exports.EXTENSION_NAME = exports.DESIGN_TEMPLATE = exports.ALL_DOMAINS_KEY = void 0;

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var ALL_DOMAINS_KEY = _UrlPathParams.ALL_DOMAINS;
exports.ALL_DOMAINS_KEY = ALL_DOMAINS_KEY;
var DESIGN_TEMPLATE = 'DesignTemplate';
exports.DESIGN_TEMPLATE = DESIGN_TEMPLATE;
var EXTENSION_NAME = 'extensionName';
exports.EXTENSION_NAME = EXTENSION_NAME;
var FOLDER = 'folder';
exports.FOLDER = FOLDER;
var GENERATED_FROM_LAYOUT_ID = 'generatedFromLayoutId';
exports.GENERATED_FROM_LAYOUT_ID = GENERATED_FROM_LAYOUT_ID;
var ID = 'id';
exports.ID = ID;
var IS_FROM_LAYOUT = 'isFromLayout';
exports.IS_FROM_LAYOUT = IS_FROM_LAYOUT;
var LABEL = 'label';
exports.LABEL = LABEL;
var PATH = 'path';
exports.PATH = PATH;
var TEMPLATE_TYPE = 'templateType';
exports.TEMPLATE_TYPE = TEMPLATE_TYPE;
var TYPE = 'type';
exports.TYPE = TYPE;
var IS_READ_ONLY = 'isReadOnly';
exports.IS_READ_ONLY = IS_READ_ONLY;